<template>
<div class="clientListVue">
  <!-- Main Body Content area -->
       <div class="o-main-content-area o-main-content-area--padBotoomNone">

           <!-- Heading Section -->
           <div class="row c-responsive-fixwidth">
               <div class="col-md-6">
                   <h1 class="h1">Clients</h1>
               </div>
               <div class="col-md-6 text-right">
                   <ul class="o-filter-area">

                       <li class="o-search-field">
                           <div class="input-group stylish-input-group">
                               <input type="text" class="form-control" placeholder="Client Search" v-model="search_query">
                               <span class="input-group-addon">
                                       <button type="submit">
                                           <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                               </button>
                               </span>
                           </div>
                       </li>
                       <li><a href="javascript: void(0)" @click="addClient()" class="c-common-btn c-common-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Client</a></li>
                   </ul>
               </div>
           </div>
           <!-- /Heading Section -->

           <!-- list head -->
           <div class="c-common-space c-responsive-fixwidth">
               <div class="col-md-12 o-tab-area o-no-padding">
                   <ul class="o-tab-view o-tab-view--text">
                       <li><a href="javascript: void(0)" @click="changeStatus('active')" :class="{'active': status == 'active'}">Active</a></li>
                       <li><a href="javascript: void(0)" @click="changeStatus('inactive')" :class="{'active': status == 'inactive'}">Inactive</a></li>
                   </ul>
               </div>
           </div>
           <!-- /list head -->


       </div>
       <!-- /Main Body Content area -->

       <!-- Individual calls section area -->
       <div class="o-ndividualArea c-responsive-fixwidth">
          <activeClient :myProp="search_query" v-if = "status == 'active'"/>
          <inactiveClient :myProp="search_query" v-if = "status == 'inactive'"/>
       </div>
</div>

</template>
<script>
    import activeClient from './activeClient.vue';
    import inactiveClient from './inactiveClient.vue';
    export default {
        components: {
            'activeClient': activeClient,
            'inactiveClient' : inactiveClient
        },
        data() {
            return {
                'status': 'active',
                'search_query' : ''
            }
        },
        methods: {

            changeStatus(status) {
                this.status = status;
            },
            addClient() {
                this.$router.push({
                    'path': '/addClient'
                });
            },

        }
    }

</script>
<style scoped>
/* @media (min-width: 1023px) and (min-width: 1500px){ */
        .margin-t-50{
            margin-top: 50px!important;
        }

        .c-radius3 {
            margin-top: 0 !important;
        }
    /* } */
</style>



// WEBPACK FOOTER //
// src/components/superAdmin/clientList.vue